var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('impact-goal-outcome-stakeholder-dialog',{attrs:{"impact-goal":_vm.impactGoal,"impact":_vm.impact}})
}
var staticRenderFns = []

export { render, staticRenderFns }